import React, { Component, ReactNode } from "react";
import { GtmService } from "../GtmService";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";
import classNames from "classnames";
import { CloseButton } from "../CloseButton/CloseButton";

type ErrorBoundaryState = {
	hasError: boolean;
};

type ErrorBoundaryProps = {
	message: string;
	children: ReactNode;
	closeModal: () => void;
	className?: string;
};

export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: any, errorInfo: any) {
		GtmService.genericError(error.message);
	}

	render() {
		if (this.state.hasError) {
			return (
				<>
					<CloseButton onClick={this.props.closeModal} />
					<ErrorMessage
						className={classNames(
							"ErrorBoundary__errorMessage",
							this.props.className
						)}
						message={this.props.message}
					/>
				</>
			);
		}

		return this.props.children;
	}
}
